import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './customerActionTypes';
import * as actions from './customerActions';
import * as endpoints from '../../services/endpoints';
import * as alert from '../alert/alertActions';

function* getCustomerSaga(action) {
  try {
    const { data } = yield call(endpoints.getCustomer, action.payload);
    yield put(actions.getCustomerSuccess(data));
  } catch (e) {
    yield put(actions.getCustomerError(e));
  }
}

function* addCustomerSaga(action) {
  try {
    const { data } = yield call(endpoints.addCustomer, action.payload);
    yield put(actions.addCustomerSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Müşteri başarıyla oluşturuldu',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/customers');
        }, 1500);
      }
    }
  } catch (e) {
    yield put(actions.addCustomerError(e));
  }
}

function* updateCustomerSaga(action) {
  try {
    const { data } = yield call(endpoints.updateCustomer, action.payload);
    yield put(actions.updateCustomerSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Müşteri başarıyla güncellendi',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/customers');
        }, 1000);
      }
    }
  } catch (e) {
    yield put(actions.updateCustomerError(e));
  }
}

function* deleteCustomerSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteCustomer, action.payload);
    yield put(actions.deleteCustomerSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Müşteri başarıyla silindi',
        variant: 'success',
      }));
      yield put(actions.getCustomerRequest({}));
    }
  } catch (e) {
    yield put(actions.deleteCustomerError(e));
  }
}

function* watchGetCustomer() {
  yield takeEvery(types.GET_CUSTOMER_REQUEST, getCustomerSaga);
}
function* watchAddCustomer() {
  yield takeEvery(types.ADD_CUSTOMER_REQUEST, addCustomerSaga);
}
function* watchUpdateCustomer() {
  yield takeEvery(types.UPDATE_CUSTOMER_REQUEST, updateCustomerSaga);
}
function* watchDeleteCustomer() {
  yield takeEvery(types.DELETE_CUSTOMER_REQUEST, deleteCustomerSaga);
}

export function* customerSaga() {
  yield all([
    watchGetCustomer(),
    watchAddCustomer(),
    watchUpdateCustomer(),
    watchDeleteCustomer(),
  ]);
} 